import { Component, OnInit,ViewChild } from '@angular/core';
import { category } from '../models/category';
import { ImageCompressService } from 'ng2-image-compress';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from '../service/tableUtility.service';

@Component({
  selector: 'app-product-category',
  templateUrl: './product-category.component.html',
  styleUrls: ['./product-category.component.css']
})
export class ProductCategoryComponent implements OnInit {

  displayedColumns = ['name','logo','adminUserName','status','createdDate','modifiedDate','Action']
  myurl:any
  categoryAddObj:category
pic: any;
image = { 'URL': '', 'valid': false };
dataSource:any
country:any
 show:boolean=false
 showFilter:boolean=false
 userSessionData:any
 showCustomisedSearch:boolean=false;
  searchValue:any;
  filterValueSelected:any;
 userDetails:any
 @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("category") form: any;
  @ViewChild("categoryUpdate", { static: true }) formUpdate: any;
  tableData: any;
  constructor(private toastr: ToastrManager,private cs:CucurachaAdminService,private excelService: ExcelService) {
    this.categoryAddObj=new category()
    this.myurl = this.cs.endpoint;
   }
   filter() {
    this.getAllCategories()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""



    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""




    }
  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForSavedList(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllCategories()
    }
  }
  exportTable() {
    this.tableData = (this.dataSource.filteredData)
    this.excelService.exportAsExcelFile(this.tableData, 'Adminuser');
    this.cs.exportLogAdd(this.userDetails.emailId,'category managment').subscribe((data) => {
    })
  }
  addProductCategory(){
    this.pic=""
    if(this.show==false){
      this.show=true

    }
    else{
      this.show=false

    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  saveCategory(){
    console.log(this.userDetails)
    this.categoryAddObj.adminId=this.userDetails._id
    this.categoryAddObj.adminUserName=this.userDetails.emailId

    this.cs.saveCategory(this.categoryAddObj).subscribe((data) => {
      if (data.result) {
        this.getAllCategories();
        this.toastr.successToastr(data.message);
        this.form.reset();
        this.pic = ""


      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    });
  }
  getAllCategories(){
    this.cs.getAllCategory().subscribe((data) => {
      console.log(data)
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator

    });
  }
  onChange(status, id) {
    console.log(status.checked)
    this.cs.getCategoryById(id).subscribe((data) => {
      this.categoryAddObj._id = data[0]._id;

      this.categoryAddObj.id = data[0].id;
      this.categoryAddObj.status = status.checked;

      this.cs.updateCategoryStatus(this.categoryAddObj).subscribe((data) => {
        if(data.result ){
          this.ngOnInit();
          this.toastr.infoToastr(data.message);
          this.form.reset();
          
          }
         else if(data.err){
          this.toastr.warningToastr(data.message);
    
         }
          else{
            this.toastr.errorToastr(data.message);
    
          }
      })
    })
  }
  fileChangeEvent(fileInput: any) {
    ImageCompressService.filesToCompressedImageSource(fileInput.target.files).then(observableImages => {
      observableImages.subscribe((image) => {
        this.image.URL = image.compressedImage.imageDataUrl;
        this.categoryAddObj.logo = image.compressedImage.imageDataUrl;
        this.categoryAddObj.logo = this.categoryAddObj.logo.replace("data:image/gif;base64,", "");
        this.categoryAddObj.logo = this.categoryAddObj.logo.replace("data:image/jpeg;base64,", "");
        this.categoryAddObj.logo = this.categoryAddObj.logo.replace("data:image/jpg;base64,", "");
        this.categoryAddObj.logo = this.categoryAddObj.logo.replace("data:image/png;base64,", "");
        this.pic = image.compressedImage.imageDataUrl
      }, (error) => {
        this.toastr.errorToastr("Error while converting");
      });
    });
  }
  getCategoryById(id: any) {
    this.cs.getCategoryById(id).subscribe((data) => {
      this.categoryAddObj._id = data[0]._id;

      this.categoryAddObj.id = data[0].id;
      this.categoryAddObj.name = data[0].name
  
      this.pic = this.myurl + 'misc/Images/categorylogos/' + data[0]._id
    })

  }
  updateCategory() {
    this.cs.updateCategory(this.categoryAddObj).subscribe((data) => {
      if (data.result) {
        this.getAllCategories();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();

      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    });

  }
  deleteCategory(id: any) {
    this.cs.deleteCategory(id).subscribe((data) => {
      this.getAllCategories()
      this.toastr.warningToastr("Data  Deleted");


    })

  }
  ngOnInit(): void {
    this.getAllCategories()
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
     
    })
  }
}
